import { BusinessUser } from '@models/businesses';

export interface TitlePlusStateModel {
	connectedIds?: string[];
	error: boolean;
	loaded: boolean;
	loading: boolean;
}

export const defaultTitlePlusStateModel: TitlePlusStateModel = {
	connectedIds: [],
	error: false,
	loaded: false,
	loading: true,
};

export interface ConnectedUser extends BusinessUser {
	name: string;
	connected: boolean;
}

export enum CONNECTION_STATUS {
	CONNECTING = 'Connecting',
	CONNECTED = 'Connected',
	DISCONNECTED = 'Disconnected',
	ERRORED = 'Errored',
}
